export { default } from './PeuEscrutini';
